/**
 * @fileoverview GET handler for the "/apps/:app_group_id/email/draganddrop_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdEmailDraganddropSettings } from "./constants";
import type { DragAndDropEditorSettings } from "./types";

export const getDragAndDropEditorSettings = reactQueryFetcherAdapter(
  appsAppGroupIdEmailDraganddropSettings,
  (signal: AbortSignal, appGroupId: string): Promise<DragAndDropEditorSettings> => {
    return fetch(`/apps/${appGroupId}/email/draganddrop_settings`, "GET", {}, { signal });
  }
);
